import { takeLatest, takeEvery, all } from "redux-saga/effects";

import API from "../services/ApiSauce";

/* ------------- Types ------------- */
import { StartupTypes } from "../reducers/StartupReducer";
import { AuthenTypes } from "../reducers/AuthenReducer";
import { UserTypes } from "../reducers/UserReducer";
import { OrganizationTypes } from "../reducers/OrganizationReducer";

/* ------------- Sagas ------------- */
import { startup } from "./StartupSaga";
import { loginRequest } from "./AuthenSaga";
import { getMe } from "./UserSaga";
import {  getAllAdmins, fetchOrganizationLogs, getOrganizationAppointments }
	from "./OrganizationSaga";

const apiSauce = API.create();

const root = function* () {
	yield [
		takeEvery(StartupTypes.STARTUP, startup),
		takeEvery(AuthenTypes.LOGIN_REQUEST, loginRequest, apiSauce),
		takeEvery(UserTypes.GET_USER_REQUEST, getMe, apiSauce),
		takeEvery(OrganizationTypes.GET_ALL_ADMINS_REQUEST, getAllAdmins, apiSauce),
		takeEvery(OrganizationTypes.FETCH_ORGANIZATION_LOGS_REQUEST, fetchOrganizationLogs, apiSauce),
		takeEvery(OrganizationTypes.GET_ORGANIZATION_APPOINTMENTS_REQUEST, getOrganizationAppointments, apiSauce),
	];
};

export default root;
export { apiSauce };


// WEBPACK FOOTER //
// ./src/sagas/index.js